// extracted by mini-css-extract-plugin
module.exports = {"main":"_30HJA0DsrvB-q3su_Kj4yI","titulo":"_2wumgZgGmUQefEflZzjG2a","ul":"_2SYmsC47Jm6WdEXWQRNhhE","li":"_1aoMxtSAm-kN7iMzEIweGs","nome":"_17w99quRLeyZCSCknkOJy1"};